(() => {
  const DURATION = 500;
  const WHEEL_THRESHOLD = 24;
  const SWIPE_THRESHOLD = 50;
  const EDGE_TOLERANCE = 1;

  const GESTURE_END = 140;
  const HOLD_STEP = 900;
  const SUSTAIN_RATIO = 0.6;

  const container = document.querySelector('.container.cf.parallax-section');
  if (!container) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const isVisible = (el) => getComputedStyle(el).display !== 'none';
  const layers = Array.from(container.children).filter(
    (el) =>
      getComputedStyle(el).getPropertyValue('--layer-stack').trim() === '1' && isVisible(el)
  );

  const footer = document.getElementById('pagefooter');
  if (footer && isVisible(footer)) layers.push(footer);

  if (layers.length < 2) return;

  layers.forEach((el, i) => {
    el.classList.add('layer-stack__layer');
    el.style.zIndex = String(i + 1);
  });
  document.documentElement.classList.add('layer-stack-on');

  let current = 0;
  let lockUntil = 0;
  let wheelDelta = 0;

  let armed = true;
  let idleTimer = null;
  let lastStepAt = 0;

  let gesturePeak = 0;

  const locked = () => performance.now() < lockUntil;

  let videoTimer = null;

  const syncVideos = () => {
    layers[current].querySelectorAll('video[autoplay]').forEach((video) => {
      const played = video.play();
      if (played) played.catch(() => {});
    });

    clearTimeout(videoTimer);
    videoTimer = setTimeout(() => {
      layers.forEach((el, i) => {
        if (i === current) return;
        el.querySelectorAll('video').forEach((video) => video.pause());
      });
    }, DURATION);
  };

  document.addEventListener(
    'play',
    (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;

      const layer = layers.find((el) => el.contains(video));
      if (!layer || layer === layers[current]) return;

      video.pause();
    },
    true
  );

  const render = () => {
    layers.forEach((el, i) => {
      el.classList.toggle('layer-stack__layer--in', i <= current);
      el.setAttribute('aria-hidden', i === current ? 'false' : 'true');
    });

    syncVideos();
  };

  const go = (next) => {
    const target = Math.max(0, Math.min(layers.length - 1, next));
    if (target === current) return;

    current = target;
    lockUntil = performance.now() + DURATION;
    lastStepAt = performance.now();
    wheelDelta = 0;
    render();
  };
  const consumesScroll = (direction) => {
    const el = layers[current];
    const overflow = getComputedStyle(el).overflowY;
    if (overflow !== 'auto' && overflow !== 'scroll') return false;

    const remaining = el.scrollHeight - el.clientHeight - el.scrollTop;
    if (direction > 0) return remaining > EDGE_TOLERANCE;
    return el.scrollTop > EDGE_TOLERANCE;
  };

  window.addEventListener(
    'wheel',
    (event) => {
      const direction = Math.sign(event.deltaY);
      if (!direction) return;
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        armed = true;
        wheelDelta = 0;
        gesturePeak = 0;
      }, GESTURE_END);

      gesturePeak = Math.max(gesturePeak, Math.abs(event.deltaY));

      if (consumesScroll(direction)) return;
      if (locked()) return;

      if (!armed) {
        const aindaEmpurra =
          performance.now() - lastStepAt >= HOLD_STEP &&
          Math.abs(event.deltaY) >= gesturePeak * SUSTAIN_RATIO;
        if (!aindaEmpurra) return;
      }

      if (Math.sign(wheelDelta) !== direction) wheelDelta = 0;
      wheelDelta += event.deltaY;

      if (Math.abs(wheelDelta) < WHEEL_THRESHOLD) return;

      go(current + direction);
      armed = false;
    },
    { passive: true }
  );

  let touchStartY = null;

  window.addEventListener(
    'touchstart',
    (event) => {
      touchStartY = event.touches[0].clientY;
    },
    { passive: true }
  );

  window.addEventListener(
    'touchend',
    (event) => {
      if (touchStartY === null) return;
      const travelled = touchStartY - event.changedTouches[0].clientY;
      touchStartY = null;

      const direction = Math.sign(travelled);
      if (!direction || Math.abs(travelled) < SWIPE_THRESHOLD) return;
      if (consumesScroll(direction)) return;
      if (locked()) return;

      go(current + direction);
    },
    { passive: true }
  );

  window.addEventListener('keydown', (event) => {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.altKey) return;
    const target = event.target instanceof Element ? event.target : null;
    if (target && target.closest('input, textarea, select, [contenteditable="true"]')) return;

    const forward = ['ArrowDown', 'PageDown', ' ', 'Spacebar'];
    const backward = ['ArrowUp', 'PageUp'];

    let next = null;
    if (forward.includes(event.key)) next = current + 1;
    else if (backward.includes(event.key)) next = current - 1;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = layers.length - 1;
    else return;

    const direction = next > current ? 1 : -1;
    if (consumesScroll(direction)) return;

    event.preventDefault();
    if (locked()) return;
    go(next);
  });

  render();
})();
